(() => {
  'use strict';
  if (window.__cmRestockSoft20261014) {
    window.__cmRestockSoft20261014.scan();
    return;
  }

  const runtimes = new Map();
  const rootSelector = '[data-restock-section]';
  const cardSelector = '[data-restock-card]';
  const dateFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const releaseDate = (card) => {
    const seconds = Number(card.dataset.restockReleaseAt);
    if (!Number.isFinite(seconds) || seconds <= 0) return null;
    const date = new Date(seconds * 1000);
    if (!Number.isFinite(date.getTime())) return null;
    const parts = Object.fromEntries(dateFormat.formatToParts(date).map(({ type, value }) => [type, value]));
    return { key: String(seconds), date: `${parts.year}.${parts.month}.${parts.day}`, time: `${parts.hour}:${parts.minute}`, iso: date.toISOString() };
  };

  const attach = (section) => {
    if (!section || section.dataset.restockCollectionPage === 'true') return;
    const id = section.dataset.restockSection;
    const previous = runtimes.get(id);
    if (previous?.section === section) return;
    previous?.dispose();

    section.dataset.restockSoft = 'date';
    let frame = 0;
    let lastTrack = null;
    let lastCards = [];
    let lastState = '';
    let disposed = false;
    const observe = () => observer.observe(section, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['hidden', 'data-restock-release-at']
    });
    const render = () => {
      frame = 0;
      if (disposed || !section.isConnected) return;
      const track = section.querySelector('[data-restock-card-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll(cardSelector));
      const state = cards.map(card => `${card.hidden ? '0' : '1'}:${card.dataset.restockReleaseAt || ''}`).join('|');
      if (track === lastTrack && state === lastState && cards.length === lastCards.length
        && cards.every((card, index) => card === lastCards[index])) return;

      observer.disconnect();
      const groups = new Map();
      const output = document.createDocumentFragment();
      cards.forEach((card) => {
        const release = releaseDate(card);
        card.toggleAttribute('data-restock-soft-dated', Boolean(release));
        if (card.hidden) return;
        const key = release?.key || 'undated';
        if (!groups.has(key)) {
          const group = make('section', 'cm-restock-soft__date-group');
          group.dataset.restockSoftDateGroup = key;
          const heading = make('h3', 'cm-restock-soft__date-heading');
          heading.id = `restock-soft-date-${id}-${groups.size + 1}`;
          if (release) {
            const time = make('time', 'cm-restock-soft__date-day', release.date);
            time.dateTime = release.iso;
            heading.append(time, make('span', 'cm-restock-soft__date-time', `${release.time} 再販売`));
          } else {
            heading.textContent = '再販売のお知らせ';
          }
          const list = make('div', 'cm-restock-soft__date-products');
          group.setAttribute('aria-labelledby', heading.id);
          group.append(heading, list);
          output.append(group);
          groups.set(key, list);
        }
        groups.get(key).append(card);
      });
      cards.filter(card => card.hidden).forEach(card => output.append(card));
      track.replaceChildren(output);
      lastTrack = track;
      lastCards = Array.from(track.querySelectorAll(cardSelector));
      lastState = lastCards.map(card => `${card.hidden ? '0' : '1'}:${card.dataset.restockReleaseAt || ''}`).join('|');
      section.dataset.restockSoftGroupCount = String(groups.size);
      observe();
    };
    const schedule = () => {
      if (!disposed && !frame) frame = window.requestAnimationFrame(render);
    };
    const observer = new MutationObserver(schedule);
    const dispose = () => {
      disposed = true;
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      if (runtimes.get(id)?.section === section) runtimes.delete(id);
    };
    runtimes.set(id, { section, dispose });
    observe();
    render();
  };

  const scan = (scope = document) => {
    runtimes.forEach(runtime => {
      if (!runtime.section.isConnected) runtime.dispose();
    });
    scope.querySelectorAll('script[data-cm-restock-soft-section]').forEach((script) => {
      const wrapper = script.closest('.shopify-section');
      const section = wrapper?.querySelector(rootSelector);
      if (section?.dataset.restockSection === script.dataset.cmRestockSoftSection) attach(section);
    });
  };
  window.__cmRestockSoft20261014 = { scan };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    runtimes.forEach(runtime => {
      if (event.target.contains(runtime.section)) runtime.dispose();
    });
  });
  scan();
})();
